import { InventoryItemFilter } from '../../inventory-items/inventoryItemFilter';
import { ProductGroupFilter } from '../../products/productGroupFilter';
import { ProductGroup } from '../../products/productGroup';
import { ProductConfiguration } from '../../products/productConfiguration';
import { CouplerStyle } from '../../coupler-styles/couplerStyle';
import PropTypes from 'prop-types';
import React, { Component } from 'react';
import { Input } from 'reactstrap';
import { Dropdown } from '@ami/react/core';
import { FilterForm, FilterInputRow, FilterSearchRow } from '@ami/react/core';
import { isNullOrUndefined } from 'util';
import { appConfig } from '@ami/react/core';
import { CarriersDropdown } from '../../machines/CarriersDropdown';
import MachineMakeAndModelFilterComponent from '../../machines/MachineMakeAndModelFilterComponent';
import CouplerStylesAsyncDropdown from '../../coupler-styles/CouplerStylesAsyncDropdown';

export class InventoryItemFilterComponent extends Component {
  constructor() {
    super();
    this.handleCarrierChange = this.handleCarrierChange.bind(this);
  }

  static propTypes = {
    filter: PropTypes.instanceOf(InventoryItemFilter),
    onChange: PropTypes.func.isRequired,
    onFilter: PropTypes.func.isRequired,
  };

  state = {
    productConfiguration: new ProductConfiguration(),
    dependentFiltersDisabled: true,
    productGroups: [],
    couplerStyles: [],
  };

  async componentDidMount() {
    const isPublic = appConfig.isCustomerApp;
    const productGroups = await ProductGroup.search(
      new ProductGroupFilter(),
      undefined,
      isPublic
    );
    const couplerStyles = !appConfig.isManagementApp
      ? []
      : await CouplerStyle.search();
    const productConfiguration = await ProductConfiguration.get(isPublic);
    this.setState({ productConfiguration, productGroups, couplerStyles });
  }

  updateFilter = (filter) =>
    this.props.onChange({ ...this.props.filter, ...filter });

  getWeightCategories = () => {
    const carrierId = this.props.filter.carrierId;
    if (!carrierId) return [];
    return this.state.productConfiguration.carriers.find(
      (x) => x.id === carrierId
    ).weightCategories;
  };

  getProductGroups = () => {
    const carrierId = this.props.filter.carrierId;
    if (!carrierId) return [];
    return this.state.productGroups
      .filter((x) => x.carrierId === carrierId)
      .map((x) => ({ id: x.id, label: x.label, imageUrl: x.imageUrl }));
  };

  handleCarrierChange(carrierId) {
    this.updateFilter({
      carrierId,
      weightCategoryId: undefined,
      productGroupId: undefined,
    });
    this.setState({
      dependentFiltersDisabled:
        isNullOrUndefined(carrierId) || carrierId === '',
    });
  }

  render() {
    const { filter } = this.props;
    if (this.state.productConfiguration.carriers.length === 0) {
      return 'Loading...';
    }

    return (
      <FilterForm onSearch={() => this.props.onFilter()}>
        <FilterInputRow label="Search">
          <Input
            placeholder="Search by name, part #, serial #"
            value={this.props.filter.search}
            onChange={(e) => this.updateFilter({ search: e.target.value })}
            onKeyPress={(e) => {
              if (e.charCode === 13) this.props.onFilter();
            }}
          />
        </FilterInputRow>
        <FilterInputRow label="Carrier">
          <CarriersDropdown
            placeholder="All"
            items={this.state.productConfiguration.carriers}
            selectedId={filter.carrierId}
            onChange={this.handleCarrierChange}
            isClearable={true}
          />
        </FilterInputRow>
        {(appConfig.isManagementApp || appConfig.isDealerApp) ? (
          <MachineMakeAndModelFilterComponent
            filter={filter}
            updateFilter={this.updateFilter}
          />
        ) : null}
        {(appConfig.isManagementApp || appConfig.isDealerApp) ? (
          <FilterInputRow label="Coupler Style">
            <CouplerStylesAsyncDropdown
              carrierId={filter.carrierId}
              weightCategoryId={filter.weightCategoryId}
              placeholder={'All'}
              onChange={(e) =>
                this.updateFilter({
                  couplerStyleId: e ? e.id : null,
                  couplerStyleName: e ? e.label : '',
                })
              }
              selected={
                filter.couplerStyleId
                  ? {
                      id: filter.couplerStyleId,
                      label: filter.couplerStyleName,
                    }
                  : null
              }
            />
          </FilterInputRow>
        ) : null}
        <FilterInputRow label="Weight Category">
          <Dropdown
            placeholder="All"
            noOptions="Please select a carrier first"
            items={this.getWeightCategories()}
            selectedId={filter.weightCategoryId}
            onChange={(weightCategoryId) =>
              this.updateFilter({ weightCategoryId })
            }
            disabled={this.state.dependentFiltersDisabled}
            isClearable={true}
          />
        </FilterInputRow>
        <FilterInputRow label="Product Group">
          <Dropdown
            placeholder="All"
            noOptions="Please select a carrier first"
            items={this.getProductGroups()}
            selectedId={this.props.filter.productGroupId}
            onChange={(productGroupId) => this.updateFilter({ productGroupId })}
            disabled={this.state.dependentFiltersDisabled}
            isClearable={true}
            forceSearchable={true}
          />
        </FilterInputRow>
        {appConfig.isManagementApp ? (
          <FilterInputRow label="Sold/Available">
            <Dropdown
              placeholder="All"
              items={[
                { id: 1, label: 'Sold' },
                { id: 2, label: 'Available' },
              ]}
              selectedId={this.props.filter.soldStatus}
              onChange={(soldStatus) => this.updateFilter({ soldStatus })}
              isClearable={true}
            />
          </FilterInputRow>
        ) : null}
        <FilterSearchRow />
      </FilterForm>
    );
  }
}
